/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_Costs_CreditsInputs */

const en_directory_ai_tools_costs_credits = /** @type {(inputs: Directory_Ai_Tools_Costs_CreditsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credits per video`)
};

const zh_directory_ai_tools_costs_credits = /** @type {(inputs: Directory_Ai_Tools_Costs_CreditsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每条消耗积分`)
};

/**
* | output |
* | --- |
* | "Credits per video" |
*
* @param {Directory_Ai_Tools_Costs_CreditsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_costs_credits = /** @type {((inputs?: Directory_Ai_Tools_Costs_CreditsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Costs_CreditsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_costs_credits(inputs)
	return zh_directory_ai_tools_costs_credits(inputs)
});
export { directory_ai_tools_costs_credits as "directory.ai_tools.costs.credits" }